import React, { useState, createContext, useContext } from 'react';
export type UserRole = 'ADMIN' | 'SUPPLIER' | 'STAFF';
interface User {
  name: string;
  role: UserRole;
  email: string;
}
interface AuthContextType {
  user: User | null;
  login: (role: UserRole) => void;
  logout: () => void;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export function AuthProvider({
  children
}: {
  children: ReactNode;
}) {
  const [user, setUser] = useState<User | null>(null);
  const login = (role: UserRole) => {
    const mockUsers: Record<UserRole, User> = {
      ADMIN: {
        name: 'John Admin',
        role: 'ADMIN',
        email: 'admin@das.com'
      },
      SUPPLIER: {
        name: 'Global Supplier',
        role: 'SUPPLIER',
        email: 'ops@global.com'
      },
      STAFF: {
        name: 'Ahmed Staff',
        role: 'STAFF',
        email: 'ahmed@warehouse.com'
      }
    };
    setUser(mockUsers[role]);
  };
  const logout = () => setUser(null);
  return <AuthContext.Provider value={{
    user,
    login,
    logout
  }} data-id="element-153">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}